import colors from './colors'
import sizes from './sizes'

export default {
  colors,
  sizes
}
